import { Component, EventEmitter, Input } from '@angular/core';
import { BaseViewComponent } from '@sb/library/base';

@Component({
    selector: 'lib-radio-card [value]',
    templateUrl: './form-field-radio-card.component.html',
    styleUrls: ['./form-field-radio-card.component.scss'],
})
export class FormFieldRadioCardComponent<T> extends BaseViewComponent {

    @Input() value!: T;
    @Input() qaTag: string = '';
    @Input() completed: boolean = false;
    @Input() isReadOnly: boolean = false;
    @Input() hasSelectedState: boolean = false;

    private _cardClicked: boolean = false;
    private _disabled: boolean = false;
    private _showRadioButton: boolean = false;

    clicked: EventEmitter<void> = new EventEmitter();

    @Input()
    set disabled(value: boolean) {
        this._disabled = value;
    }

    CardClicked(): void {
        //this function is used in the group component
        if (!this._disabled) {
            this._cardClicked = true;
            this.clicked.emit();
        }
    }

    get cardClicked(): boolean {
        return this._cardClicked;
    }

    set cardClicked(value: boolean) {
        this._cardClicked = value;
    }

    get showRadioButton(): boolean {
        return this._showRadioButton;
    }

    set showRadioButton(value: boolean) {
        if (value) {
            this._showRadioButton = value;
        }
    }

    get disabled(): boolean {
        return this._disabled;
    }

}
